import React, { useEffect, useRef, useState } from "react";
import "./Career.css";
import Header2 from "../../Layout/Header2";
import img from "../../Images/Rectangle 427 (2).png";
import img2 from "../../Images/a_modern_male_teacher_with_a_laptop_smiling_and_isolated_on_a_transparent_background_g_1_1_1 1 (2).png";
import img3 from "../../Images/a03e08c3-02a7-499f-8e8a-09d24884a5df 1 (1).png";
import PopularJob from "./PopularJob";
import HomeService from "../../Services/HomeService";
import HttpClientXml from "../../utils/HttpClientXml";
import { toast } from "react-toastify";
import { openWhatsAppLink } from "../../Component/OpenWhatsApp";
const styles = {
  modalOverlay: {
    position: 'fixed',
    top: 0, left: 0,
    width: '100vw', height: '100vh',
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex', alignItems: 'center', justifyContent: 'center'
  },
  modal: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    width: '50%',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)'
  }
};
const Career = () => {

  const [filterData, setFilterData] = useState({
    category: "",
    city: ""
  })

  const[listingTitle,setListingTitle]=useState("Featured Jobs")
  const [jobCategories, setJobCategories] = useState([])
  const fetchAllJobCategories = async () => {
    try {
      const res = await HomeService.getJobCategories();
      if (res?.status) {
        console.log("SET16", res.data);
        setJobCategories(res.data.filter(item => item.status));
      }
    } catch (error) {
      console.error("Error adding property:", error);
    }
  }

  const [cities, setCities] = useState([])
  const fetchCity = async () => {
    try {
      const res = await HomeService.getAllCityList();
      console.log("FGH56", res);

      if (res?.status) {
        setCities(res.data);
      }
    } catch (error) {
      console.error("Error fetching city:", error);
    }
  };

  const handleFilter = (e) => {
    e.preventDefault()
  }

  useEffect(() => {
    fetchAllJobCategories()
    fetchCity()
  }, [])

  const [isModalOpen, setIsModalOpen] = useState(false);
  const initialFormData = {
    jobCategoryId: "",
    city: "",
    name: "",
    email: "",
    phone: "",
    cvFile: ""
  }
  const [formData, setFormData] = useState(initialFormData);

  const handleAttachmentUpload = async (e) => {
    const files = e.target.files;
    const uploadedImages = [];

    for (let i = 0; i < files.length; i++) {
      const data = new FormData();
      data.append("cvFile", files[i]);

      try {
        const res = await HttpClientXml.fileUplode(
          "file-upload",
          "POST",
          data
        );
        console.log("UYTRE59", res);

        if (res?.status && res?.doc) {
          setFormData({ ...formData, [e.target.name]: res.doc })
        }
      } catch (error) {
        toast.error("Failed to upload image: " + files[i].name);
        console.error("Error uploading image:", error);
      }
    }

    // setImages((prevImages) => [...prevImages, ...uploadedImages]);
    // toast.success("Images uploaded successfully!");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('SEE48', formData);
    // return
    try {
      const response = await HomeService.applyJob(formData);
      console.log("XDE45", response);

      if (response?.status) {
        setFormData(initialFormData)
        toast.success(response.message)
      }
    } catch (err) {
      console.error("Error", err);
    }
    setIsModalOpen(false); // Close modal after submit
  };

  const sectionRef = useRef(null);

  const handleScroll = (e) => {
    e.preventDefault()
    // setListingTitle("Searched Jobs")
    sectionRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <section className="career_section">
        <div className="career_wrapper_main">
          <Header2 />

          <div className="career_black_div">
            <div className="left_career_section">
              <h1 className="career_head">
                Boost your
                <br />
                <span className="career_span_head"> Business with us</span>
              </h1>
              <p className="career_span_para">
                Discover a curated collection of dream homes at your fingertips,
                simplified and personalized.
              </p>
              <p className="career_para2">
                Come join us and build your dream team with us
              </p>

              <div className="career_input_div">
                <select
                  name="category"
                  value={filterData?.category || ""}
                  className="career_input"
                  onChange={(e) => {
                    setFilterData((prevData) => ({
                      ...prevData,
                      category: e.target.value,
                    }));
                  }}
                >
                  <option value="">Choose Category...</option>
                  {
                    jobCategories.map((item, key) => {
                      return (
                        <><option value={item?._id}>{item?.catName}</option></>
                      )
                    })
                  }
                </select>

                {/* <select className="career_input">
                  <option value="">Select Location</option>
                </select> */}

                <input type="text" className="career_input" placeholder="Enter location"
                  name="city"
                  value={filterData?.city || ""}
                  onChange={(e) => {
                    setFilterData((prevData) => ({
                      ...prevData,
                      city: e.target.value,
                    }));
                  }}
                >
                </input>


                {/* <select
                  name="city"
                  value={filterData?.city || ""}
                  className="career_input"
                  onChange={(e) => {
                    setFilterData((prevData) => ({
                      ...prevData,
                      city: e.target.value,
                    }));
                  }}
                >
                  <option value="">Choose City...</option>
                  {
                    cities
                      .map((type) => (
                        <option key={type?._id} value={type?._id}>
                          {type?.name}
                        </option>
                      ))}
                </select> */}

                <div className="maginfy_search_div"
                  style={{ cursor: "pointer" }}
                  onClick={(e)=>{
                    setListingTitle("Searched Jobs")
                    handleScroll(e)}}
                >
                  <i className="fa-solid fa-magnifying-glass"></i>
                </div>
              </div>
            </div>
            <div
              onClick={(e) => handleFilter(e)}
              className="right_career_section">
              <img src={img} />
            </div>
          </div>
        </div>

        <div className="employees_candidates_wrapper">
          <div className="employees_div">
            <div className="left_employee_div">
              <h6>For Employers</h6>
              <p>
                Find professionals from around the world and across all skills.
              </p>
              <button className="employee_btn"
                onClick={(e) => openWhatsAppLink(e, "919876543210", "I am interested to post job openings at your website")}
              >Post Jobs For Free</button>
            </div>
            <div className="right_employee_div">
              <img src={img2} />
            </div>
          </div>
          <div className="candidates_div">
            <div className="left_employee_div">
              <h6 className="text-dark">For Candidates</h6>
              <p className="text-dark">
                Build your professional profile, find new job opportunities.
              </p>
              <button className="employee_btn bg-dark text-light"
                onClick={() => {
                  setIsModalOpen(true)
                }}
              >
                Upload Your CV
              </button>
            </div>
            <div className="right_employee_div">
              <img src={img3} />
            </div>
          </div>
        </div>
      </section>
      <a ref={sectionRef} id="my-section"></a>
      <PopularJob filterData={filterData} listingTitle={listingTitle} />
      

      {isModalOpen && (
        <div style={styles.modalOverlay}>
          <div style={styles.modal}>
            <div className="client_in_hand_wrapper">
              {/* Close Button */}
              <button
                className="modal_close_button"
                onClick={() => setIsModalOpen(!isModalOpen)}
              >
                &times;
              </button>
              <div className="client_head_div">
                <h3>Application Form</h3>
              </div>
              <div className="community_form_wrapper_div">
                <form
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    rowGap: "10px",
                  }}
                >
                  <div className="community_input_flex_wrapper">
                    <div className="form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">
                          Category
                        </label>
                        <div className="community_input_wrapper_div">
                          <select
                            name="jobCategoryId"
                            value={formData?.jobCategoryId || ""}
                            onChange={(e) => {
                              setFormData((prevData) => ({
                                ...prevData,
                                jobCategoryId: e.target.value,
                              }));
                            }}
                          >
                            <option value="">Choose Category...</option>
                            {
                              jobCategories.map((item, key) => {
                                return (
                                  <><option value={item?._id}>{item?.catName}</option></>
                                )
                              })
                            }
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="community_input_flex_wrapper">
                    <div className="form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">
                          Location
                        </label>
                        <div className="community_input_wrapper_div">
                          <input
                            value={formData?.city}
                            onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                            placeholder="Enter your preferred location"
                            type="text"
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="community_input_flex_wrapper">
                    <div className="form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">
                          Name
                        </label>
                        <div className="community_input_wrapper_div">
                          <input
                            value={formData?.name}
                            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                            placeholder="Enter your name"
                            type="text"
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="community_input_flex_wrapper">
                    <div className="form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">
                          Email
                        </label>
                        <div className="community_input_wrapper_div">
                          <input
                            value={formData?.email}
                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                            placeholder="Enter your active email address"
                            type="email"
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="community_input_flex_wrapper">
                    <div className="form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">
                          Phone
                        </label>
                        <div className="community_input_wrapper_div">
                          <input
                            value={formData?.phone}
                            onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                            placeholder="Enter your active phone number"
                            type="text"
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="community_input_flex_wrapper">
                    <div className="form_wrappr">
                      <div className="community_form_filed_wrapper">
                        <label className="community_form_label">
                          Resume
                        </label>
                        <div className="community_input_wrapper_div">
                          {formData?.cvFile &&
                            <a href={formData?.cvFile} target="_blank">
                              {formData?.cvFile?.split('.').pop().toLowerCase() === "docx" || formData?.cvFile?.split('.').pop().toLowerCase() === "doc" ? <><i class="fas fa-2x fa-file-word"></i></> : formData?.cvFile?.split('.').pop().toLowerCase() === "pdf" ? <><i class="fas fa-2x fa-file-pdf"></i></> : "NO file uploaded"}
                            </a>
                          }
                          <input
                            type="file"
                            name="cvFile"
                            className="form-control"
                            onChange={(e) => handleAttachmentUpload(e)}
                            // accept="image/*"
                            accept=".doc,.docx,.pdf"
                          />
                        </div>
                      </div>
                    </div>

                  </div>

                  <div className="community_form_submit_div">
                    <button onClick={(e) => handleSubmit(e)}>
                      Submit
                    </button>
                    {/* <button style={{ marginLeft: "1em" }} onClick={() => {
                          setIsModalOpen(!isModalOpen);
                        }}>
                          Cancel
                        </button> */}
                  </div>
                </form>
              </div>
            </div>
          </div >
        </div >
      )}
    </>
  );
};

export default Career;
